var map = {
	"./Antman_01.png": "f37d",
	"./BlackWidow_01.png": "9230",
	"./Bucky_01.png": "2f2a",
	"./CaptainMarvel_A_01.png": "778e",
	"./CaptainMarvel_B_01.png": "dfe0",
	"./Coulson_01.png": "2f18",
	"./Hulk_01.png": "3364",
	"./NickFury_01.png": "4953",
	"./Result_Advanced_0608_01.png": "f897",
	"./Result_Advanced_0608_01_2.png": "5a65",
	"./Result_Beginner_0608_01.png": "2a5f",
	"./Result_Beginner_0608_01_2.png": "5e00",
	"./Result_Best_0608_01.png": "30a3",
	"./Result_Best_0608_01_2.png": "0f68",
	"./Result_MidHigh_0608_01.png": "82dd",
	"./Result_MidHigh_0608_01_2.png": "4b75",
	"./Result_Mid_0608_01.png": "813d",
	"./Result_Mid_0608_01_2.png": "c08e",
	"./Thanos_01.png": "c280",
	"./Thor_01.png": "699e"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "bb6e";